core.constant('applicationMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "ERROR": {
          "ERROR": "Błąd",
          "INTERNAL_ERROR": "Wystąpił błąd aplikacji!",
          "ACCESS_DENIED": "Nie masz uprawnień do wykonania danej akcji!",
          "NOT_FOUND": "Strona o podanym adresie nie została znaleziona!",
          "ALERT": "Uwaga!",
          "CONTACT_ADMINISTRATOR": "Skontaktuj się z administratorem.",
          "AUTHENTICATION_ERROR": "Wprowadzono błędną nazwę użytkownika lub hasło.",
          "PESEL_ALREADY_EXISTS": "Pacjent z wprowadzonym numerem PESEL już istnieje.",
          "EMAIL_ALREADY_EXISTS": "Pacjent z wprowadzonym adresem e-mail już istnieje.",
          "VISIT_DATE_MUST_BE_IN_FUTURE": "Data i czas rozpoczęcia wizyty muszą być w przyszłości.",
          "EDM_EXCEPTION" : "Wystąpił błąd, prosimy spróbować ponownie później",
          "ERROR_DURING_SAVE" : "Wystąpił błąd podczas zapisywania. Prosimy spróbować ponownie później.",
          "CODE_MISMATCH" : "Kod weryfikacyjny jest niepoprawny",
          "INVALID_USER" : "Niepoprawny użytkownik.",
          "INVALID_USER_OR_PASSWORD" : "Niepoprawny użytkownik lub hasło.",
          "TOKEN_EXPIRATION" : "Token wygasł",
          "WRONG_PASSWORD" : "Niepoprawne hasło",
          "DUPLICATED_EMAIL" : "Adres email jest już zajęty",
          "PASSWORD_ALREADY_USED" : "Hasło było już wykorzystane",
          "TERM_COLLISION_DETECTED" : "Zidentyfikowano kolizje terminów z aktualnie istniejącymi.",
          "AVAILABILITY_COLLISION_DETECTED" : "Zidentyfikowano kolizje dostępności z aktualnie istniejącymi.",
          "COLLISION_DETECTED" : "Zidentyfikowano kolizje terminów z aktualnie istniejącymi.",
          "TOKEN_EXPIRATION" : "Token wygasł",
          "OFFICE_USER_CAN_ONLY_EDIT_OWN_ENTRIES" : "Użytkownik recepcji może edytować tylko wpisy swojego autorstwa",
          "MAX_OFFICES_NUMBER_REACHED" : "Niestety nie możesz dodać kolejnego gabinetu. Maksymalna liczba gabinetów wynosi 7.",
          "VISIT_CARD_NOT_FILLED_OUT_ALL_REQUIRED_FIELDS" : "Karta wizyty nie ma wypełnionych wszystkich wymaganych pól.",
          "WRONG_TERM_STATE" : "Niepoprawny stan terminu",
          "LOST_CONNECTION" : "Utracono połączenie z pacjentem.",
          "LOSE_SOCKET_CONNECTION" : "Twoja przeglądarka zerwała połączenie 'socketowe'. Twoi pacjenci nie są w stanie przedzwonić do Ciebie. Prosimy, abyś odświeżył stronę.",
          "CANT_MODIFY_ALREADY_PRINTED_SICK_LEAVE": "Nie można edytować wydrukowanego skierowania lekarskiego.",
          "ERROR_DURING_GETTING_ALAB_OFFERS" : "Błąd przy pobieraniu ofert ALABowych.",
          "USER_NOT_IN_EDM":  "Lekarz nie ma uzupełnionych wszystkich danych",
          "DUPLICATED_PATIENT": "Pacjent o podanym numerze pesel już istnieje"
        },
        "VALIDATION": {
          "VALIDATION_MESSAGE": "Uzupełnij poprawnie wszystkie pola!",
          "REQUIRED": "Pole wymagane",
          "REQUIRED_INT": "Pole wymagane (liczba)",
          "REQUIRED_INT_MIN": "Pole wymagane, liczba całkowita. Minimum: {{ min }}",
          "REQUIRED_INT_MAX": "Pole wymagane, liczba całkowita. Maximum: {{ max }}",
          "REQUIRED_INT_MIN_MAX": "Pole wymagane, liczba całkowita z zakresu od {{ min }} do {{ max }}",
          "REQUIRED_REAL_MIN": "Pole wymagane, liczba zmiennoprzecinkowa. Minimum: {{ min }}",
          "REQUIRED_REAL_MAX": "Pole wymagane, liczba zmiennoprzecinkowa. Maximum: {{ max }}",
          "REQUIRED_REAL_MIN_MAX": "Pole wymagane, liczba z zakresu od {{ min }} do {{ max }}",
          "REQUIRED_STRING": "Pole wymagane (tekst)",
          "REQUIRED_MAX": "Pole wymagane, maksimum {{ max }} znaków",
          "REQUIRED_MIN_MAX": "Pole wymagane, długość {{ min }} - {{ max }} znaków",
          "OPTIONAL_MIN_MAX": "Pole opcjonalne, długość {{ min }} - {{ max }} znaków",
          "OPTIONAL_MAX": "Pole opcjonalne, maksimum {{ max }} znaków",
          "OPTIONAL_INT_MIN": "Pole opcjonalne, liczba całkowita. Minimum: {{ min }}",
          "OPTIONAL_INT_MAX": "Pole opcjonalne, liczba całkowita. Maximum: {{ max }}",
          "OPTIONAL_INT_MIN_MAX": "Pole opcjonalne, liczba całkowita z zakresu od {{ min }} do {{ max }}",
          "OPTIONAL_REAL_MIN": "Pole opcjonalne, liczba zmiennoprzecinkowa. Minimum: {{ min }}",
          "OPTIONAL_REAL_MAX": "Pole opcjonalne, liczba zmiennoprzecinkowa. Maximum: {{ max }}",
          "OPTIONAL_REAL_MIN_MAX": "Pole opcjonalne, liczba zmiennoprzecinkowa z zakresu od {{ min }} do {{ max }}",
          "EMAIL": "Podaj poprawny adres email",
          "PHONE": "Podaj poprawny numer telefonu w formacie XXXXXXXXX",
          "DATE": "Podaj poprawną datę w formacie DD-MM-RRRR",
          "DATE_OUT_OF_RANGE": "Podana data jest poza dopuszczalnym zakresem",
          "PWZ": "Podaj poprawny numer PWZ",
          "KRS": "Podaj poprawny numer KRS",
          "NIP": "Podaj poprawny numer NIP",
          "REGON": "Podaj poprawny numer REGON",
          "PESEL": "Podaj poprawny numer PESEL",
          "POST_CODE": "Podaj poprawny kod pocztowy",
          "NUMBER_MIN_MAX": "Wprowadź liczbę z przedziału {{ min }} - {{ max }}",
          "NUMBER_MIN": "Wprowadź liczbę większą lub równą {{ min }}",
          "NUMBER_MAX": "Wprowadź liczbę mniejszą lub równą {{ max }}",
          "DATE_OUT_OF_RANGE": "Wprowadź datę w dopuszczalnym zakresie",
          "INVALID_DATE_TIME": "Wprowadź datę i godzinę w dopuszczalnym zakresie",
          "INVALID_PWZ" : "Niepoprawny PWZ",
          "DIFFERENT_PASSWORDS" : "Hasła nie są takie same!",
          "PASSWORD_IS_TOO_WEAK" : "Hasło jest za słabe!"
        },
        "MESSAGE": {
          "VIEW_DATA_LOSS_CONFIRMATION": "Wszystkie niezapisane zmiany zostaną utracone. Czy na pewno chcesz opuścić ten widok",
          "COOKIE": {
            "HEADER": "Ta strona używa Cookies",
            "NOTICE": "Na naszych stronach internetowych stosujemy ciasteczka (pliki cookies), dzięki którym poznajemy preferencje naszych użytkowników oraz ułatwiamy korzystanie z serwisu. Warunki przechowywania lub dostępu do cookies mogą zostać skonfigurowane w ustawieniach przeglądarki internetowej. Korzystając z naszych serwisów internetowych bez zmiany ustawień przeglądarki wyrażasz zgodę na stosowanie plików cookies.",
            "MORE": "Dowiedz się więcej"
          }
        },
        "NOTIFICATION": {
          "OPERATION_SUCCEEDED": "Operacja zakończona pomyślnie.",
          "OPERATION_FAILED": "Operacja zakończona niepowodzeniem.",
          "NOT_ENOUGH_DATA_TO_PERFORM_SIMULATION": "Brak wystarczającej ilości danych w zbiorze treningowym do przeprowadzenia symulacji."
        }
      },
      "UI": {
        "APPLICATION": {
          "BROWSER_TITLE": "Meedy Lekarz",
          "APPLICATIONS": "Aplikacje",
          "HOME_PAGE": "Strona główna",
          "OK": "OK",
          "CANCEL": "Anuluj",
          "ADD": "Dodaj",
          "CHANGE": "Zmień",
          "EDIT": "Edytuj",
          "EDIT_DATA" : "Edytuj dane",
          "DELETE": "Usuń",
          "SAVE": "Zapisz",
          "BACK": "Cofnij",
          "GO_BACK": "Powrót",
          "REFRESH": "Odśwież",
          "CLEAR": "Wyczyść",
          "CLOSE": "Zamknij",
          "CHOOSE": "Wybierz",
          "CHOOSE_FILE": "Wybierz plik",
          "SHOW_DETAILS": "Pokaż",
          "WARNING": "Uwaga",
          "YES": "Tak",
          "NO": "Nie",
          "ACTIVATE": "Aktywuj",
          "DEACTIVATE": "Dezaktywuj",
          "CONTINUE" : "Kontynuuj",
          "SEND": "Wyślij",
          "HIDE": "Schowaj",
          "SHOW": "Pokaż",
          "GO_TO_HOME_PAGE": "Przejdź do strony głównej",
          "ENCLOSE_FILE": "Dołącz pliki",
          "ZL": "zł",
          "SUM_ZL": "Suma [zł]",
          "COST_ZL": "Koszt [zł]",
          "TODAY": "Dzisiaj",
          "TOMORROW": "Jutro",
          "RULES": "REGULAMIN",
          "WELCOME" : "Powitanie",
          "CONTINUE_WITHOUT_FILLING" : "Kontynuuj bez wypełnienia",
          "FILL_MY_DATA" : "Wypełnij moje dane",
          "PASSWORD_IS_EXPIRED" : "Hasło wygasło!",
          "YOUR_PASSWORD_IS_EXPIRED" : "Twoje hasło wygasło.",
          "PLEASE_PUT_NEW_PASSWORD" : "Prosimy, by podać nowe hasło dostępu.",
          "CHANGE_PASSWORD" : "Zmień hasło",
          "DOWNLOAD_DAILY_PLAN" : "Pobierz Plan Dnia",
          "WP_ANNEX": {
            "TITLE": "Aneks do umowy",
            "MESSAGE": "<p>Dzień dobry,</p><p>Poszerzamy możliwości!<br>Będziemy do Państwa mogli kierować także tych pacjentów, którzy w ramach Serwisu Wirtualnej Polski chcą się umawiać telefonicznie. Dotychczasowe zaufanie, jakim się cieszymy, wyzwania organizacyjne i technologiczne skłoniły Wirtualną Polskę do podjęcia decyzji o zmianie z dniem 01.02.2019 roku charakteru umów zawieranych ze świadczeniodawcami medycznymi z trójstronnego na dwustronny przenosząc prawa i obowiązki na Saneo S.A. (Meedy).</p><p>Wszystkie dotychczasowe zasady współpracy pozostają bez zmian, a dodatkowo udostępniamy Państwu możliwość przyjmowania pacjentów umawiających się drogą telefoniczną w ramach Serwisu.<br>Uprzejmie prosimy o zapoznanie się z treścią oraz podpisanie aneksu.</p>",
            "CAUTION": "<p>Uwaga! Jeżeli do 31.01.2019 aneks nie zostanie podpisany, umowa trójstronna będzie musiała zostać wypowiedziana, dlatego bardzo prosimy o priorytetowe działanie za co najmocniej dziękujemy.</p>",
            "ADDITIONAL_INFO": "W przypadku pytań, prosimy o kontakt pod nr tel. <a href=\"tel:616262560\">61 62 62 560</a> bądź mailem <a href=\"mailto:kontraktowanie@meedy.pl\">kontraktowanie@meedy.pl</a>",
            "DOWNLOAD_ANNEX": "Pobierz treść aneksu",
            "SIGN": "Podpisz aneks",
            "REMIND_LATER": "Przypomnij później"
          }
        },
        "DATA_GRID": {
          "ITEMS_PER_PAGE": "Na stronie",
          "PAGE": "Strona"
        },
        "MENU": {
          "CHANGE_PASSWORD" : "Zmień hasło",
          "HELP" : "Filmy instruktażowe"
        },
        "SIDEBAR": {
          "USERS": "Użytkownicy",
          "RIGHTS": "Uprawnienia",
          "CALENDAR": "Kalendarz",
          "PATIENTS": "Pacjenci",
          "MESSAGES": "Komunikaty",
          "INVOICES_ORDERS": "Faktury/zlecenia",
          "CONFIGURATION": "Ustawienia",
          "DELEGATE_TO_ALAB": "Zleć do ALAB"
        },
        "TABBAR": {
        },
        "BREADCRUMB": {
          "ERROR": "Błąd",
          "HOMEPAGE": "Strona główna"
        },
        "BUTTON": {
          "YES" : "Tak",
          "NO" : "Nie"
        }
      },
      "DATA": {
        "TODAY": "Dzisiaj",
        "ALERT": "Uwaga",
        "LIST": "Lista",
        "NO_DATA": "Brak",
        "NOT_SET": "Brak",
        "NAME": "Nazwa",
        "DESCRIPTION": "Opis",
        "HEADER": "Nagłówek",
        "FIRST_NAME": "Imię",
        "LAST_NAME": "Nazwisko",
        "TITLE": "Tytuł",
        "PHONE": "Telefon",
        "EMAIL": "Email",
        "TYPE": "Typ",
        "STATUS": "Status",
        "DATE": "Data",
        "AUTHOR": "Autor",
        "RECEIVER": "Odbiorca",
        "CONTENT": "Treść",
        "VIEW": "Podgląd",
        "FROM": "Od",
        "TO": "Do",
        "ALL": "Wszystkie",
        "LANGUAGE": "Język / Sprache",
        "ABBREVIATION": {
          "YEAR": "r."
        }
      },
      "ENUM": {
        "STATUS_REASON_TYPE": {
          "ACTIVE": "Aktywny",
          "INACTIVE": "Nieaktywny",
          "BLOCKED": "Zablokowany",
          "DELETED": "Usunięty"
        }
      },
      "MODULE": {
        "TITLE": {
        },
        "INTERNAL": {
          "STATUS": {
            "NAME": "Status",
            "REASON": "Przyczyna",
            "DESCRIPTION": "Opis"
          }
        },
        "WELCOME_CLINICS" : {
          "WELCOME_IN_MEEDY_DOCTORS": "Witaj w Meedy Clinic"
        }
      }
    },
    "SYSTEM": {
      "VALIDATION": {
        "REQUIRED": "Pole wymagane",
        "EMAIL": "Podaj poprawny adres email",
        "PHONE": "Podaj poprawny numer telefonu w formacie XXXXXXXXX",
        "DATE": "Podaj poprawną datę w formacie DD-MM-RRRR",
        "REQUIRED_MAX": "Pole wymagane, maksimum {{ max }} znaków",
        "DATE_OUT_OF_RANGE": "Podana data jest poza dopuszczalnym zakresem",
        "PWZ": "Podaj poprawny numer PWZ",
        "KRS": "Podaj poprawny numer KRS",
        "NIP": "Podaj poprawny numer NIP",
        "REGON": "Podaj poprawny numer REGON",
        "PESEL": "Podaj poprawny numer PESEL",
        "POST_CODE": "Podaj poprawny kod pocztowy",
        "REQUIRED_MIN_MAX": "Pole wymagane, długość {{ min }} - {{ max }} znaków",
        "REQUIRED_INT_MIN_MAX": "Pole wymagane, liczba całkowita z zakresu od {{ min }} do {{ max }}"
      },
      "MESSAGE": {
      },
      "NOTIFICATION": {
      }
    },
    "UI": {
      "APPLICATION": {
      },
      "DATA_GRID": {
        "ITEMS_PER_PAGE": "Na stronie",
        "PAGE": "Strona"
      },
      "TABBAR": {
      },
      "BREADCRUMB": {
        "ERROR": "Błąd",
        "HOMEPAGE": "Strona główna"
      }
    },
    "DATA": {
    },
    "ENUM": {
    },
    "MODULE": {
      "WELCOME_CLINICS" : {
        "WELCOME_IN_MEEDY_DOCTORS": "Witaj w Meedy Clinic"
      },
      "WELCOME" : {
        "WELCOME_IN_MEEDY_DOCTORS" : "Witaj w Meedy Doctors",
        "ALL_DATA_IN_ONE_PLACE" : "Wszystkie dane Twoich pacjentów w jednym miejscu.",
        "REQUEST" : {
          "P1" : "Prosimy Cię o poświęcenie kilku minut i ",
          "LINK" : "wypełnienie danych",
          "P2" : " wymaganych przez ustawę o Elektronicznej Dokumentacji Medycznej. Bez nich nie będziesz mógł skorzystać z pełnej funkcjonalności serwisu."
        },
        "CAN_FILL_DATA" : "Możesz uzupełnić je później w zakładce ",
        "WHERE_FILL_DATA" : "Ustawienia -> Moje dane."
      },
      "TITLE": {
      },
      "INTERNAL": {
        "STATUS": {
          "NAME": "Status",
          "REASON": "Przyczyna",
          "DESCRIPTION": "Opis"
        }
      }
    }
  }
});


